import { Routes } from "./Routes";
import { GlobalStyle } from "./Styles";

function App() {
  return (
    <>
      <Routes />
      <GlobalStyle />
    </>
  );
}

export default App;
